import { Link } from "react-router-dom";
import { simMnpCampaignLinks } from "@/data/simMnpCampaignLinks";

const offers = [
  {
    id: "ahamo",
    name: "ahamo",
    benefit: "dポイント 20,000pt",
    plan: "30GB・月2,970円",
    condition: "端末を買わずにMNP。開通前月または当月に、申込みと同じdアカウントでエントリー",
    receipt: "4,000ptずつ5カ月。期間・用途限定",
  },
  {
    id: "uq",
    name: "UQ mobile",
    benefit: "au PAY残高 20,000円相当",
    plan: "コミコミプランバリュー：35GB・月3,828円",
    condition: "au・povo以外からMNP。オンラインでSIMのみ契約し、増量オプションⅡに同時加入",
    receipt: "開通の翌月下旬以降。au PAYの設定が必要",
  },
  {
    id: "linemo",
    name: "LINEMO",
    benefit: "PayPayポイント 最大12,000円相当",
    plan: "ベストプランV：30GB・月2,970円",
    condition: "ソフトバンク・Y!mobile・LINEモバイルからの乗り換えは対象外。申込翌月末までに開通し、ベストプランVを開通月の6カ月後まで維持",
    receipt: "開通月の7カ月後の上旬にコード送付。受取日を含め30日以内にチャージ",
  },
  {
    id: "ymobile",
    name: "Y!mobile",
    benefit: "PayPayポイント Sは5,000円相当／M・Lは15,000円相当",
    plan: "シンプル3 S：5GB・月3,278円",
    condition: "ソフトバンク系からの乗り換えは対象外。オンラインでSIMのみ契約し、データ増量オプションに同時加入",
    receipt: "開通月の翌々月にコード送付。翌々月末までにチャージ",
  },
  {
    id: "rakuten",
    name: "楽天モバイル",
    benefit: "楽天ポイント 14,000pt",
    plan: "Rakuten最強プラン：3GBまで月1,078円、20GBまで月2,178円、20GB超は月3,278円",
    condition: "三木谷キャンペーン専用ページから申し込み、クーポン適用・開通・Rakuten Linkで10秒以上通話",
    receipt: "5,000pt・5,000pt・4,000ptの3回。期間限定",
  },
] as const;

export default function SimMnpCampaignArticle() {
  return <>
    <section id="answer">
      <p className="text-[1.08em] leading-[1.9] text-foreground-900">今のiPhoneをそのまま使う、またはAppleなどでiPhoneを購入する。そんな人が回線だけ乗り換えるなら、どのMNP特典を選べばよいでしょうか。</p>
      <p><strong>SIM・eSIMのみのMNPは、端末代と特典を分けて比べられます。</strong>ただし「20,000円相当」という数字だけでは決まりません。対象となる乗り換え元、必要な申込手順、毎月の通信費が違います。</p>
      <aside><strong>先に結論</strong><p>30GBと5分通話を使うならahamo、au回線や店舗相談を重視するならUQ mobile、少量から30GBまで選びたいならLINEMOやY!mobile、月の使用量が変わるなら楽天モバイルも候補です。先に自分の使い方を決めてから、受け取れる特典を確認しましょう。</p></aside>
    </section>

    <section id="compare">
      <h2>SIMのみMNP特典を5社で比べる</h2>
      <p>2026年10月5日に各社の公式ページで再確認した特典です。表は「他社から電話番号を引き継ぎ、端末を同時購入しない」場合。ポイントや残高は現金値引きではなく、使える場所・時期も異なります。</p>
      <p>月額は税込の基本料金の例です。容量が違うため金額順には選べません。割引、通話料、特典獲得に必要なオプション料金は含めていません。</p>
      <div className="not-prose my-7 overflow-x-auto border-y-2 border-foreground-900 bg-white">
        <table className="w-full min-w-[1050px] border-collapse text-left text-sm">
          <thead className="bg-background-100"><tr><th scope="col" className="p-3">会社</th><th scope="col" className="p-3">MNP特典</th><th scope="col" className="p-3">プラン・月額の例</th><th scope="col" className="p-3">見落としやすい条件</th><th scope="col" className="p-3">受取時期・方法</th></tr></thead>
          <tbody>
            {offers.map((offer) => <tr key={offer.id} className="border-t border-background-300 align-top">
              <th scope="row" className="p-3">{offer.name}</th>
              <td className="p-3 font-bold text-primary-700">{offer.benefit}</td>
              <td className="p-3">{offer.plan}</td>
              <td className="p-3">{offer.condition}</td>
              <td className="p-3">{offer.receipt}</td>
            </tr>)}
          </tbody>
        </table>
      </div>
      <p>LINEMOの最大20,000円相当の増額は2026年10月4日で終了しました。表は通常特典（ベストプランVは12,000円相当、ベストプランは10,000円相当）です。ワイモバイルは10月1日から、Sは5,000円相当、M・Lは15,000円相当へ変更されています。楽天の14,000ptは三木谷キャンペーンで、通常の10,000pt特典とは合算しません。</p>
    </section>

    <section id="choice">
      <h2>特典額より先に、使う容量と申込条件を見る</h2>
      <p>例えば30GBを使う人と3GBで足りる人では、毎月の通信費が違います。一度だけもらう特典より、使い続ける月額の差が大きくなることもあります。</p>
      <ol>
        <li><strong>直近3カ月の使用量を見る。</strong>必要な容量より大きなプランへ、特典だけを理由に申し込まない。</li>
        <li><strong>乗り換え元を確認する。</strong>UQはau・povo、Y!mobileとLINEMOは一部のソフトバンク系回線からの乗り換えが表の特典対象外です。</li>
        <li><strong>受取条件まで比べる。</strong>ahamoの事前エントリー、UQとY!mobileの増量オプション、楽天の専用ページとRakuten Link、LINEMOのプラン維持を確認する。</li>
      </ol>
      <p>毎月の料金・データ量も比べたい人は、<Link to="/articles/which-plan-is-cheapest">使用量別の料金比較</Link>から、自分に近い容量帯を選んでください。</p>
    </section>

    <section id="device">
      <h2>iPhoneも同時に買うなら、比較を分ける</h2>
      <p>この表はSIMのみの特典です。通信会社でiPhoneを同時購入すると、端末割引や返却プログラムの条件に切り替わり、SIMのみのポイントが対象外になる場合があります。特にahamoの20,000ptは端末同時購入が対象外です。</p>
      <p>iPhone 18 Proを通信会社で購入する人は、<Link to="/articles/iphone-18-pro-mnp">購入先と2年返却の比較</Link>へ。Appleなどで端末だけを購入する人は、このページのSIMのみ特典を確認できます。</p>
    </section>

    <section id="apply">
      <h2>条件を確認してから申込先へ</h2>
      <p>申込経路によって特典が変わります。特に楽天の三木谷キャンペーンは専用ページとクーポンコード、ahamoはエントリーが必要です。ahamoは広告リンク、ほかの4社は公式特典ページへつながります。</p>
      <div className="not-prose my-7 grid gap-3 sm:grid-cols-2">
        {offers.map((offer) => {
          const destination = simMnpCampaignLinks[offer.id];
          if (destination.kind === "affiliate" && destination.adMarkup) {
            return <div key={offer.id} className="border-y-2 border-foreground-900 bg-white p-5">
              <span className="text-xs font-bold text-primary-600">PR</span>
              <strong className="mt-1 block text-base text-foreground-900">{offer.name}｜{offer.benefit}</strong>
              <div className="mt-2 text-sm text-primary-700 underline" dangerouslySetInnerHTML={{ __html: destination.adMarkup }} />
            </div>;
          }
          return <a key={offer.id} href={destination.applicationUrl} target="_blank" rel="noopener noreferrer" className="block border-y-2 border-foreground-900 bg-white p-5 no-underline hover:bg-background-50">
            <span className="text-xs font-bold text-primary-600">公式特典ページ</span>
            <strong className="mt-1 block text-base text-foreground-900">{offer.name}｜{offer.benefit}</strong>
            <span className="mt-2 block text-sm text-foreground-700">条件を確認する ↗</span>
          </a>;
        })}
      </div>
      <p>受け取れる特典は申込経路や時期によって変わります。各社の<a href="#sources">公式条件</a>で対象となる乗り換え元と期限を確認してください。</p>
    </section>

    <section id="sources">
      <h2>各社の公式条件</h2>
      <ul>
        {offers.map((offer) => <li key={offer.id}><a href={simMnpCampaignLinks[offer.id].conditionsUrl} target="_blank" rel="noopener noreferrer">{offer.name}：対象条件・受取方法 ↗</a></li>)}
      </ul>
      <p>月額料金：<a href="https://ahamo.com/plan/" target="_blank" rel="noopener noreferrer">ahamo</a>、<a href="https://shop.uqmobile.jp/shop/lp01/" target="_blank" rel="noopener noreferrer">UQ mobile</a>、<a href="https://www.linemo.jp/lp/0000/" target="_blank" rel="noopener noreferrer">LINEMO</a>、<a href="https://www.ymobile.jp/jusetsu/jusetsu04/" target="_blank" rel="noopener noreferrer">Y!mobile</a>、<a href="https://network.mobile.rakuten.co.jp/fee/saikyo-plan/detail/" target="_blank" rel="noopener noreferrer">楽天モバイル</a>の公式料金表で確認できます。</p>
      <p>キャンペーン確認日：2026年10月5日。特典額、申込期限、対象プランは変更されます。申込み前にリンク先の現行条件を確認してください。</p>
    </section>
  </>;
}
